import { render, staticRenderFns } from "./InspectionIssueBadgeCheckpointBox.vue?vue&type=template&id=f1440410&scoped=true"
import script from "./InspectionIssueBadgeCheckpointBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionIssueBadgeCheckpointBox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionIssueBadgeCheckpointBox.vue?vue&type=style&index=0&id=f1440410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1440410",
  null
  
)

export default component.exports